import React from "react";
import { useNavigate } from "react-router-dom";
import { BreadcrumbItem, Breadcrumbs } from "@vds/breadcrumbs";
import "../../styles.css";

const BreadcrumbsContainer = ({ config = [] }) => {
  const navigate = useNavigate();

  const handleNavigate = (path, navigateState) => {
    navigate(path, { state: navigateState });
  };

  return (
    <Breadcrumbs surface="light">
      {config.map(({ navigateTo, breadcrumbText, navigateState }, index) =>
        navigateTo ? (
          <BreadcrumbItem key={index} onClick={() => handleNavigate(navigateTo, navigateState)} className="cursor-pointer">
            {breadcrumbText}
          </BreadcrumbItem>
        ) : (
          <BreadcrumbItem key={index}>{breadcrumbText}</BreadcrumbItem>
        )
      )}
    </Breadcrumbs>
  );
};

export default BreadcrumbsContainer;
